import { motion } from "framer-motion";
import { rightDrawerOpenAtom } from "../state";
import { useAtom } from "jotai";
import { SLIDE_TRANSITION } from "../constants/animations";
import { ChevronLeftIcon, ChevronRightIcon } from "@heroicons/react/24/outline";
import clsx from "clsx";

export default function RightSidebarButton({
    onClick,
    label = "Close",
    iconDirection = "right",
}: {
    label?: string;
    onClick?: () => void;
    iconDirection?: "right" | "left";
}) {
    const [isOpen, setIsOpen] = useAtom(rightDrawerOpenAtom);

    return (
        <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: isOpen ? 1 : 0 }}
            exit={{ opacity: 0 }}
            transition={SLIDE_TRANSITION}
            className="flex items-center justify-between pb-2"
        >
            <button
                type="button"
                onClick={onClick || (() => setIsOpen(false))}
                className={clsx(
                    "menu-item ui-element subdued text-sm",
                    "mb-4 flex cursor-pointer items-center gap-1",
                )}
            >
                {iconDirection === "right" && label}
                {iconDirection === "right" ? (
                    <ChevronRightIcon className="size-3" color="#E5E7EB" />
                ) : (
                    <ChevronLeftIcon className="size-3" color="#E5E7EB" />
                )}
                {iconDirection === "left" && label}
            </button>
        </motion.div>
    );
}
